import registrationStore from 'src/stores/registrationStore';
import domSelector from 'src/utils/domSelector';
import appConfig from 'src/utils/appConfig';
import DOM_SELECTOR_CONFIG from 'src/config/domSelectorConfig';
import templates from 'src/templates/question';
import View from 'src/components/shared/view';
import { shuffle } from '../shared/shuffle';

const QUESTION_SELECTORS = DOM_SELECTOR_CONFIG.QUESTION_DATA_SELECTORS;
const DELAY_TIME = 100;

class QuestionView extends View {
  constructor() {
    super();
    this.domSelector = domSelector;
  }

  render(question, answers, options) {
    const template = this.optionHandlers.template(templates, options);
    this.destroy();
    this.appendToBody(template({
      question,
      answers: options.shuffle ? shuffle({ answers, shuffle: options.shuffle }) : answers,
      options,
      dataView: QUESTION_SELECTORS.QUESTION_VIEW,
      answersSubview: QUESTION_SELECTORS.ANSWERS_SUBVIEW,
      learningLanguage: appConfig.getLanguageTranslation(),
      firstname: registrationStore.getUserData().firstname,
      tagline: question.tagline
    }));

    this.questionContainer = this.domSelector.getQuestionContainer();
    this.answersContainer = this.domSelector.getQuestionAnswersContainer();

    this.initEvents();
  }

  initEvents() {
    this.answersContainer.addEventListener(
      'click',
      this.onAnswerSelected.bind(this)
    );
  }

  destroy() {
    if (this.answersContainer) this.answersContainer.removeEventListener('click', this.onAnswerSelected);

    this.answersContainer = null;
    this.questionContainer = null;
    super.destroy();
  }

  onAnswerSelected(event) {
    if (event.target.getAttribute('data-type') === 'answer') {
      this.selectedAnswer = {
        babbel_tracking: event.target.getAttribute('data-babbel-tracking'),
        gtm: event.target.getAttribute('data-gtm'),
        display_rank: parseInt(event.target.getAttribute('data-babbel-tracking-rank'), 10)
      };
      this.answersContainer.classList.add('slide-left-fade-out');
      this.answersContainer.setAttribute('id', 'uat-question-animation');
      setTimeout(() => this.onQuestionCompleted(), DELAY_TIME);
    }
  }

  onQuestionCompleted() {
    this.destroy();
    this.emitCompleted(this.selectedAnswer);
  }
}

export default QuestionView;
